/**
 * קובץ קונפיגורציה מרכזי - כתובות API ומשתני סביבה
 *
 * משתמש ב-REACT_APP_ prefix (Create React App)
 * קריאה אוטומטית מקובץ .env או .env.production
 */

// קריאת כתובת ה-API ממשתני סביבה
// בפיתוח: localhost:5002
// בייצור: Railway backend
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5002/api';

// הגדרות נוספות
export const config = {
  apiBaseUrl: API_BASE_URL,
  isDevelopment: process.env.NODE_ENV === 'development',
  isProduction: process.env.NODE_ENV === 'production',
};

export default config;
